import React, { useState, useEffect, useRef } from "react";

const AZURE_MAPS_KEY = process.env.REACT_APP_AZURE_MAPS_KEY;
const AZURE_MAPS_BASE_URL = "https://atlas.microsoft.com/search/fuzzy/json";

const AddressInput = ({
  value,
  onChange,
  onBlur,
  placeholder,
  className,
  name,
}) => {
  const addressValue = value || { addressText: "", lat: 0, lon: 0 };
  
  const searchResultsRef = useRef({});
  const debounceTimerRef = useRef(null);
  const [addressList, setAddressList] = useState(value ? [value] : []);
  const [inputValue, setInputValue] = useState(addressValue.addressText || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const [countryCode, setCountryCode] = useState("US");

  useEffect(() => {
    searchResultsRef.current = {};
    
    // Detect country from browser locale
    try {
      var locale = navigator.language || navigator.userLanguage || "en-US";
      var detectedCountry = locale.split("-")[1] || "US";
      setCountryCode(detectedCountry.toUpperCase());
    } catch (error) {
      console.warn("Could not detect country, defaulting to US");
    }
    
    // Cleanup function
    return function() {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (value && value.addressText && value.addressText !== inputValue) {
      setInputValue(value.addressText);
    }
  }, [value, inputValue]);
  
  const doSearch = (searchInput) => {
    if (!AZURE_MAPS_KEY) {
      console.warn("Azure Maps API key not configured");
      return;
    }

    var url = AZURE_MAPS_BASE_URL + "?api-version=1.0&subscription-key=" + encodeURIComponent(AZURE_MAPS_KEY) + "&query=" + encodeURIComponent(searchInput) + "&countrySet=" + countryCode;

    fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        var newAddressList = data.results && data.results.map(function(address) {
          return {
            addressText:
              (address.type === "POI" && address.poi && address.poi.name ? address.poi.name + ", " : "") +
              (address.address && address.address.freeformAddress ? address.address.freeformAddress : ""),
            lat: address.position && address.position.lat,
            lon: address.position && address.position.lon,
          };
        });

        searchResultsRef.current[searchInput] = newAddressList || [];
        setAddressList(searchResultsRef.current[searchInput]);
        setShowDropdown(true);
      })
      .catch(function(error) {
        console.error("Address search error:", error);
      });
  };

  const debouncedSearch = function(searchInput) {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(function() {
      doSearch(searchInput);
    }, 350);
  };

  const handleInputChange = (event) => {
    var newInputValue = event.target.value;
    setInputValue(newInputValue);

    if (newInputValue.length > 2) {
      if (searchResultsRef.current[newInputValue]) {
        setAddressList(searchResultsRef.current[newInputValue]);
        setShowDropdown(true);
      } else {
        debouncedSearch(newInputValue);
      }
    } else {
      setShowDropdown(false);
      setAddressList([]);
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    }
    
    if (onChange) {
      onChange(newInputValue ? { addressText: newInputValue } : null);
    }
  };

  const handleSelectAddress = (selectedAddress) => {
    setInputValue(selectedAddress.addressText);
    setShowDropdown(false);
    setAddressList([]);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (onChange) {
      onChange(selectedAddress);
    }
  };

  const handleBlur = () => {
    setTimeout(function() {
      setShowDropdown(false);
    }, 200);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <div className="address-autocomplete" style={{ position: "relative" }}>
      <input
        type="text"
        name={name}
        className={className}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={function() {
          if (inputValue.length > 2 && addressList.length > 0) {
            setShowDropdown(true);
          }
        }}
        placeholder={placeholder}
        autoComplete="off"
      />
      {showDropdown && addressList.length > 0 && (
        <div
          className="dropdown is-active"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
          }}
        >
          <div className="dropdown-menu" style={{ width: "100%" }}>
            <div className="dropdown-content">
              {addressList.map(function(address, index) {
                return (
                  <a
                    href="#"
                    key={index}
                    className="dropdown-item"
                    onClick={function(e) {
                      e.preventDefault();
                      handleSelectAddress(address);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {address.addressText}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressInput;